import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryConfig } from "@ws-react-query";
import {
  listRequirements,
  RequirementsListQuery
} from "../../../services/requirements/listRequirements";
import { fetchAllPagesWithConcurrency } from "../../../utils/queryUtils";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_REQUIREMENTS_FULL_LIST } from "../keys";

export const useQueryRequirementsList = (
  params?: RequirementsListQuery,
  config?: WSQueryConfig<IRequirementResponse[], WSServiceError>
) =>
  useWSQuery<IRequirementResponse[], WSServiceError>(
    [QUERY_REQUIREMENTS_FULL_LIST, params],
    async () => {
      return await fetchAllPagesWithConcurrency<IRequirementResponse>({
        requestQuery: params,
        getSummary: async () => {
          const { summary } = await listRequirements({
            ...params,
            page: { size: 1, number: 1 }
          });
          return { listSize: summary.listSize };
        },
        fetchPage: async query => {
          const response = await listRequirements(query);
          return response.data;
        },
        pageSize: 100,
        concurrentLimit: 5
      });
    },
    config
  );
